var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7071 0.292894C44.3166 -0.0976277 43.6834 -0.0976276 43.2929 0.292894L36.9289 6.65686C36.5384 7.04738 36.5384 7.68055 36.9289 8.07107C37.3195 8.46159 37.9526 8.46159 38.3431 8.07107L44 2.41422L49.6569 8.07107C50.0474 8.46159 50.6805 8.46159 51.0711 8.07107C51.4616 7.68055 51.4616 7.04738 51.0711 6.65686L44.7071 0.292894ZM4.37114e-08 36L28 36L28 34L-4.37114e-08 34L4.37114e-08 36ZM45 19L45 1L43 1L43 19L45 19ZM28 36C37.3888 36 45 28.3888 45 19L43 19C43 27.2843 36.2843 34 28 34L28 36Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightTop);
export default __webpack_public_path__ + "static/media/arrow_right_top.af96b24aad3fdd5f286bba20892d3099.svg";
export { ForwardRef as ReactComponent };